import { createAction, handleActions } from "redux-actions";
import {
    UPDATE_SEARCH_FILTER_CONDITION,
    UPDATE_SEARCH_FILTER_SIZE,
    CLEAR_SEARCH_FILTERS
} from "../types";
import scraperConfig from "../scraperConfig";

const defaultState = Object.fromEntries(
    Object.entries(scraperConfig).map(([key, value]) => [key, value.searchFilters])
);

export const updateSearchFilterCondtion = createAction(
    UPDATE_SEARCH_FILTER_CONDITION,
    (filterName, condition, index, id) => ({ filterName, condition, index, id })
);

export const updateSearchFilterSize = createAction(
    UPDATE_SEARCH_FILTER_SIZE,
    (filterName, size, id) => ({ filterName, size, id })
);

export const clearSearchFilters = createAction(CLEAR_SEARCH_FILTERS, (id) => ({
    id
}));

const updatedFilters = (state, action) => {
    return state[action.payload.id].map((filter) => {
        if (filter.name === action.payload.filterName) {
            return {
                ...filter,
                condition: action.payload.condition || filter.condition,
                index: action.payload.index || 0, // TODO: proper conditional check here
                size: action.payload.size || filter.size
            };
        }
        return filter;
    });
};

const searchFilters = handleActions(
    {
        [updateSearchFilterCondtion]: (state, action) => {
            return {
                ...state,
                [action.payload.id]: [...updatedFilters(state, action)]
            };
        },
        [updateSearchFilterSize]: (state, action) => {
            return {
                ...state,
                [action.payload.id]: [...updatedFilters(state, action)]
            };
        },
        [clearSearchFilters]: (state, action) => {
            return {
                ...state,
                [action.payload.id]: defaultState[action.payload.id]
            };
        }
    },
    defaultState
);

export default searchFilters;
